import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext";
import useApi from "../../../hooks/useApi";

const ModalNovoAmbiente = () => {

    const { closeModal } = useModal();
    const api = useApi();

    const [ loading, setLoading ] = useState(false);

    const [ formValues, setFormValues ] = useState({
        identificador: "",
        nomeEmpresa: "",
        tipoIndustria: "",
        cidade: "",
        estado: ""
    })

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormValues(prev => ({
            ...prev,
            [name]: value.toUpperCase()
        }))

    }

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        try{

            setLoading(true);

            const formData = new FormData();

            formData.append("identificador", formValues.identificador);
            formData.append("nomeEmpresa", formValues.nomeEmpresa);
            formData.append("tipoIndustria", formValues.tipoIndustria);
            formData.append("cidade", formValues.cidade);
            formData.append("estado", formValues.estado);

            const { data } = await api.post("/Painel/API/ControleMedicao/CreateObra/", formData);

            console.log( data );
            closeModal();

        }catch(e){

            console.error(e);

        }finally{

            setLoading(false);

        }

    }

    return (
        <Overlay state={true} >
            <Modal header close={ closeModal } >
                <Formulario onSubmit={ handleSubmit } >
                    <FormComp
                        title="IDENTIFICADOR"
                        type="text"
                        name="identificador"
                        valor={formValues.identificador}
                        changeFunc={handleChange}
                        maxLength={3}
                    />
                    <FormComp
                        title="NOME EMPRESA"
                        type="text"
                        name="nomeEmpresa"
                        valor={formValues.nomeEmpresa}
                        changeFunc={handleChange}
                    />
                    <FormComp
                        title="TIPO INDUSTRIA"
                        type="text"
                        name="tipoIndustria"
                        valor={formValues.tipoIndustria}
                        changeFunc={handleChange}
                    />
                    <FormComp
                        title="CIDADE"
                        type="text"
                        name="cidade"
                        valor={formValues.cidade}
                        changeFunc={handleChange}
                    />
                    <FormComp
                        title="ESTADO"
                        type="text"
                        maxLength={2}
                        name="estado"
                        valor={formValues.estado}
                        changeFunc={handleChange}
                    />
                    <FormComp
                        type="submit"
                        valor={ loading ? "SALVANDO..." : "SALVAR" }
                        disabled={ loading }
                    />
                </Formulario>
            </Modal>
        </Overlay>
    )
}

export default ModalNovoAmbiente;